import { SVGProps, Ref, forwardRef } from 'react'
const SvgFileUploadFrame = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 18V6M16.5 10.5 12 6l-4.5 4.5M6 23.25H2.253a1.5 1.5 0 0 1-1.5-1.5V2.25a1.5 1.5 0 0 1 1.5-1.5H6M18 .75h3.75a1.5 1.5 0 0 1 1.5 1.5v19.5a1.5 1.5 0 0 1-1.5 1.5H18"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgFileUploadFrame)
export default ForwardRef
